import React from 'react';
import { useNow } from '../hooks/useNow';
import { formatCountdown } from '../utils/format';
import { formatDayLong } from '../utils/lifeGrid';

/** Считаем не сутки, а день на ногах — ночь не должна фонить прогрессом. */
const WAKE_HOUR = 7;
const SLEEP_HOUR = 23;
const HOURS = SLEEP_HOUR - WAKE_HOUR;

/**
 * Мини-вьюха «сегодня»: бодрствование как 16 засечек, зачёркнутых до текущего
 * часа, фон залит на прожитую долю дня, и секунды видно уходящими. В большой
 * сетке этого движения не заметить — здесь один день растянут на всю ширину.
 */
export function TodayStrip() {
  const now = useNow(1000);
  const dayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate(), WAKE_HOUR);
  const dayEnd = new Date(now.getFullYear(), now.getMonth(), now.getDate(), SLEEP_HOUR);
  const before = now.getTime() < dayStart.getTime();
  const after = now.getTime() >= dayEnd.getTime();
  const progress = before ? 0 : after ? 1 : (now.getTime() - dayStart.getTime()) / (dayEnd.getTime() - dayStart.getTime());
  return <section className="border-line bg-paper relative shrink-0 overflow-hidden border-t" aria-label="Сегодня" data-id="element-108" data-mp="16n618bmf0uew">
      <div aria-hidden className="bg-accent-soft absolute inset-y-0 left-0" style={{
      width: `${progress * 100}%`
    }} data-id="element-109" data-mp="11oure0w4ejwo" />
      {!before && !after && <div aria-hidden className="bg-accent absolute inset-y-0" style={{
      left: `${progress * 100}%`,
      width: 2
    }} data-id="element-110" data-mp="snmunn995r4p" />}

      <div className="relative flex items-center gap-4 px-4 py-2.5 sm:gap-6 sm:px-6" data-id="element-111" data-mp="1ke13h52esd9i">
        <p className="text-muted shrink-0 font-mono text-[11px]" data-id="element-112" data-mp="1flrkya3mifh9">
          сегодня<span className="mx-1.5" data-id="element-113" data-mp="1bko3jj5xgbdx">·</span>
          <span className="text-ink" data-id="element-114" data-mp="1bjmt9gwqjsx9">{formatDayLong(now)}</span>
        </p>

        <div className="relative hidden h-4 min-w-0 flex-1 items-center sm:flex" aria-hidden data-id="element-115" data-mp="2833wf92htsjb">
          <div className="grid w-full items-center" style={{
          gridTemplateColumns: `repeat(${HOURS}, minmax(0, 1fr))`
        }} data-id="element-116" data-mp="23bc1yng7v2nw">
            {Array.from({
            length: HOURS
          }, (_, index) => <span key={index} className="flex items-center justify-center" data-id="element-117" data-mp="6dob8uz0ujdd">
                <span className={now.getHours() > WAKE_HOUR + index ? 'bg-ink' : 'bg-faint'} style={{
              width: 1,
              height: 7
            }} data-id="element-118" data-mp="3nu6665mnrx7u" />
              </span>)}
          </div>
          <span className="bg-ink absolute left-0 top-1/2 -translate-y-1/2" style={{
          width: `${progress * 100}%`,
          height: 1.5
        }} data-id="element-119" data-mp="3es6odb3tkp3u" />
        </div>

        <p className="text-muted ml-auto shrink-0 font-mono text-[11px] sm:ml-0" data-id="element-120" data-mp="34vk4opn8c43e">
          {before ? <>
              <span className="text-accent tabular-nums" data-id="element-121" data-mp="39uwmux35omzn">{formatCountdown(dayStart, now)}</span>
              <span className="ml-1.5" data-id="element-122" data-mp="134yuzaay5rx3">до начала дня</span>
            </> : after ? <span data-id="element-123" data-mp="181p6rlfpy1cp">день закончился</span> : <>
              <span className="text-ink tabular-nums" data-id="element-124" data-mp="2sk9j1ahk2eob">{Math.round(progress * 100)}%</span>
              <span className="mx-1.5" data-id="element-125" data-mp="2nlzmowk3h814">·</span>
              <span className="text-accent tabular-nums" data-id="element-126" data-mp="2nnarmzpa0ltt">{formatCountdown(dayEnd, now)}</span>
              <span className="ml-1.5" data-id="element-127" data-mp="32bdxm93bjxim">до конца дня</span>
            </>}
        </p>
      </div>
    </section>;
}